export const environment = {
    production: true,
    urlBack: 'https://jllatras.api.atalaya.ai/api/v1/',
    urlBackOffice: 'https://jllatras.atalaya.ai',
    urlFront: 'https://jllatras.app.atalaya.ai/login',
    client_id: 'UQbtaPJAdL218GW69GKgrqQlAuNSeYlc7hW2eMvw',
    client_secret:
        'mmHo3fpmpklC9LUkvU3fHiO8PVxwdPrPMfDPWATZkVRuXoialXh7Mrl37aozQQDSctsybWOxCbNYm3sINznTZ93j74PugIcQAxVaeqqssCStxr9VCkyhfLeC4UpACgWd',
};
